module.exports = __webpack_public_path__ + "img/BGIMGHOME1.918c403b.png";